<template>
  <section class="navigation-search">
    <div class="navigation-search__bar">
      <InputSearchQuery id="search" placeholder="Que cherchez-vous?" />
    </div>

    <div class="navigation-search__filters">
      <RouterLink
        :to="getContentTypeQuery('all')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': !$route.query.contentType }"
        replace
        exact
      >
        Tout le contenu
      </RouterLink>

      <RouterLink
        :to="getContentTypeQuery('page')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.contentType === 'page' }"
        replace
        exact
      >
        <SvgIcon id="content-page" />
        Pages du site
      </RouterLink>

      <RouterLink
        :to="getContentTypeQuery('project')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.contentType === 'project' }"
        replace
        exact
      >
        <SvgIcon id="content-project" />
        Projets
      </RouterLink>

      <RouterLink
        :to="getContentTypeQuery('publication')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.contentType === 'publication' }"
        replace
        exact
      >
        <SvgIcon id="content-file" />
        Publications
      </RouterLink>

      <RouterLink
        :to="getContentTypeQuery('news')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.contentType === 'news' }"
        replace
        exact
      >
        <SvgIcon id="content-news" />
        Nouvelles
      </RouterLink>

      <RouterLink
        :to="getContentTypeQuery('event')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.contentType === 'event' }"
        replace
        exact
      >
        <SvgIcon id="bullet-events" />
        Événements
      </RouterLink>
    </div>

    <div class="navigation-search__filters">
      <RouterLink
        :to="getContentTypeQuery('publication')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': isAllPublicationsActive }"
        replace
        exact
      >
        Toutes les publications
      </RouterLink>

      <RouterLink
        :to="getPublicationTypeQuery('article')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.publicationType === 'article' }"
        replace
        exact
      >
        <SvgIcon id="content-article" />
        Articles
      </RouterLink>

      <RouterLink
        :to="getPublicationTypeQuery('theme')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.publicationType === 'theme' }"
        replace
        exact
      >
        <SvgIcon id="content-folder" />
        Dossiers thématiques
      </RouterLink>

      <RouterLink
        :to="getPublicationTypeQuery('letter')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.publicationType === 'letter' }"
        replace
        exact
      >
        <SvgIcon id="content-file" />
        Lettres ouvertes
      </RouterLink>

      <RouterLink
        :to="getPublicationTypeQuery('balado')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.publicationType === 'balado' }"
        replace
        exact
      >
        <SvgIcon id="content-podcast" />
        Balados
      </RouterLink>

      <RouterLink
        :to="getPublicationTypeQuery('opinion')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.publicationType === 'opinion' }"
        replace
        exact
      >
        <SvgIcon id="content-declaration" />
        Texte d'opinion
      </RouterLink>

      <RouterLink
        :to="getPublicationTypeQuery('monitoring')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.publicationType === 'monitoring' }"
        replace
        exact
      >
        <SvgIcon id="bullet-analyse" />
        Veille informationnelle
      </RouterLink>
    </div>

    <div class="navigation-search__filters">
      <RouterLink
        :to="getEventTypeQuery('all')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': !$route.query.eventType }"
        replace
        exact
      >
        Toutes les types d'événements
      </RouterLink>

      <RouterLink
        :to="getEventTypeQuery('webinar')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.eventType === 'webinar' }"
        replace
        exact
      >
        <SvgIcon id="content-web" />
        Webinaires
      </RouterLink>

      <RouterLink
        :to="getEventTypeQuery('workshop')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.eventType === 'workshop' }"
        replace
        exact
      >
        <SvgIcon id="content-list" />
        Ateliers
      </RouterLink>

      <RouterLink
        :to="getEventTypeQuery('forum')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.eventType === 'forum' }"
        replace
        exact
      >
        <SvgIcon id="content-forum" />
        Forum
      </RouterLink>

      <RouterLink
        :to="getEventTypeQuery('award')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.eventType === 'award' }"
        replace
        exact
      >
        <SvgIcon id="content-trophy" />
        Remises de prix
      </RouterLink>

      <RouterLink
        :to="getEventTypeQuery('seminar')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.eventType === 'seminar' }"
        replace
        exact
      >
        <SvgIcon id="content-edifice" />
        Séminaires
      </RouterLink>

      <RouterLink
        :to="getEventTypeQuery('study')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.eventType === 'study' }"
        replace
        exact
      >
        <SvgIcon id="icon-book" />
        Journées d’études
      </RouterLink>

      <RouterLink
        :to="getEventTypeQuery('assembly')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.eventType === 'assembly' }"
        replace
        exact
      >
        <SvgIcon id="bullet-people" />
        Assemblées générales
      </RouterLink>

      <RouterLink
        :to="getEventTypeQuery('launch')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.eventType === 'launch' }"
        replace
        exact
      >
        <SvgIcon id="content-zoom-out" />
        Lancements
      </RouterLink>

      <RouterLink
        :to="getEventTypeQuery('consultation')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.eventType === 'consultation' }"
        replace
        exact
      >
        <SvgIcon id="content-business" />
        Consultations
      </RouterLink>
    </div>

    <KeywordPickerQuery />
  </section>
</template>

<script>
export default {
  name: 'SearchSearch',
  computed: {
    isAllPublicationsActive() {
      const isActiveWithSubType = this.$route.query.contentType === 'publication' && this.$route.query.publicationType
      return !this.$route.query.contentType || !isActiveWithSubType
    },
    isAllEventsActive() {
      const isActiveWithSubType = this.$route.query.contentType === 'event' && this.$route.query.eventType
      return !this.$route.query.contentType || !isActiveWithSubType
    }
  },
  watch: {
    '$wp.secondaryDataLoaded': {
      handler(isLoaded) {
        if (isLoaded) {
          console.log('projects', this.$wp.projects)
        }
      },
      immediate: true
    }
  },
  methods: {
    getContentTypeQuery(contentType) {
      const { page, eventType, publicationType, contentType: currentContentType, ...queryRest } = this.$route.query
      const query =
        contentType === 'all' || contentType === currentContentType ? queryRest : { ...queryRest, contentType }

      return { query }
    },
    getPublicationTypeQuery(publicationType) {
      const { page, eventType, contentType, publicationType: currentPublicationType, ...queryRest } = this.$route.query
      const query =
        currentPublicationType === publicationType
          ? queryRest
          : { ...queryRest, contentType: 'publication', publicationType }

      return { query }
    },
    getEventTypeQuery(eventType) {
      const { page, publicationType, contentType, eventType: currentEventType, ...queryRest } = this.$route.query
      const query = currentEventType === eventType ? queryRest : { ...queryRest, contentType: 'event', eventType }
      return { query }
    }
  }
}
</script>
